import React from 'react'
import { useSelector, useDispatch } from 'react-redux';
import IconCalendar from '../../shared/icons/IconCalendar'
import CustomDateRangePicker from '../../shared/CustomDateRangePicker'
import {
  setDistFromToDate,
  setDistForActivation,
} from '../../../../actions/deActions/deDistributeActions'
import ToggleSwitch from '../../shared/ToggleSwitch';
import { END_DATE_DISABLED_STATUS } from '../../shared/DEConstants';

// TODO: add calander range picker
// add switch componetn to toggle Yes/No
const RequestDateSelector = () => {
  const dispatch = useDispatch()

  const onForActivationChange = (checked) => {
    dispatch(setDistForActivation(checked));
  };

  const handleDateChange = (startDate, endDate) => {
    dispatch(setDistFromToDate(startDate, endDate))
  }
  const distRequest = useSelector(state => state.deDistribute.distRequest);
  const distErrors = useSelector(state => state.deDistribute.distErrors)
  const impersonated = useSelector(state => state.login.loginResponse.data.impersonated);
  const isToggleDisabled = ((END_DATE_DISABLED_STATUS.includes(distRequest.status)) ||
    distRequest.status === 'Active' || impersonated);
  let toggleRootClass = 'distro__activation-toggle';
  if (isToggleDisabled) {
    toggleRootClass += ' is-toggle-disabled'
  }
  return (
    <div className="distro__row distro__date-selector">
      <div className="distro__card">
        <div className="distro__card__icon">
          <IconCalendar />
        </div>
        <div className="distro__card__body">
          <div className="distro__card__copy">
            <div className="distro__date-selector--root">
              <CustomDateRangePicker
                handleDateChange={handleDateChange}
                dateFormat="MM/dd/yyyy"
                labelFrom="Start Date"
                labelTo="End Date"
                distRequest={distRequest}
                distErrors={distErrors}
                impersonated={impersonated}
              />
            </div>
            <div className={toggleRootClass}>
              <div className="distro__activation-toggle--title">
                <span>For Activation</span>
                <span>
                  <ToggleSwitch
                    id="newsletter"
                    checked={distRequest.isForActivation}
                    onChange={onForActivationChange}
                    disabled={isToggleDisabled}
                  />
                </span>
              </div>
              <div className="distro__activation-toggle--message">
                Targets used for activation in campaigns require start and end
                dates
              </div>
            </div>
            {distErrors.isDateErr && (
              <span className="date-error">{distErrors.isDateErrMsg}</span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default RequestDateSelector;
